import { Button, Card, Row, Space } from "antd";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Cargando from "../../components/Cargando";
import { contextApp } from "../../firebase/context";
import { getColection } from "../../firebase/fireStore";

const CalendarDaily = () => {
  let history = useHistory();

  const { usuario } = useContext(contextApp);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getDaily = async () => {
    setLoading(true);
    const response = (await getColection("Daily")) || [];
    const getdata = response.filter(
      (item) => item.data.email === usuario.email
    );
    setData(getdata);
    setLoading(false);
  };
  const timeToString = (fecha) => {
    const date = new Date(fecha);
    return date.toISOString().split("T")[0];
  };
  useEffect(() => {
    getDaily();
  }, []);

  return (
    <div>
      {loading && Cargando}
      <Button onClick={() => history.push("/diario")}>Nueva nota</Button>
      <Row gutter={16}>
        {data.length > 0 &&
          data.map((item, index) => (
            <Card
              onClick={() => {
                history.push("/nota", {
                  item,
                });
              }}
              key={index}
              style={{
                marginTop: 10,
                marginLeft: 10,
                width: 200,
                cursor: "pointer",
              }}
            >
              <div>
                {format(
                  new Date(timeToString(item.data.hora.toDate())),
                  "PPP",
                  {
                    locale: es,
                  }
                )}
              </div>
              <div>
                {item.data.hora.toDate().toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>

              <div>{item.data.emotion}</div>
            </Card>
          ))}
      </Row>
    </div>
  );
};

export default CalendarDaily;
